import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const HouseholdAssessmentExpenses = ({ householdAssessmentExpenses }) => {
  const householdAssessmentExpensesColumns = [
    {
      field: "internalExpenseId",
      headerName: "Internal Expense ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "householdAssessmentId",
      headerName: "Household Assessment ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "internalapplicationid",
      headerName: "Internal Application ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "expenseTypeId",
      headerName: "Expense Type ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "value",
      headerName: "Value",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
  ];

  return (
    <>
      <AccordianContainer
        id="accord"
        title="Household Assessment Expenses"
        initialOpen={false}
      >
        <Box sx={{ marginTop: "-0.5%" }}>
              <CustomDataGrid
                noDataMessage="No Data"
                rows={
                  householdAssessmentExpenses !== undefined &&
                  householdAssessmentExpenses !== null
                    ? householdAssessmentExpenses.map((item, index) => ({
                        id: index + 1,
                        ...item,
                      }))
                    : []
                }
                columns={householdAssessmentExpensesColumns}
                pageSize={15}
                pageSizeOptions={[10]}
                gridLazyLoad={() => {}}
                gridHeight={305}
                getRowId={(row) => row.internalExpenseId}
                onCellKeyDown={(event, param) => {
                  (param.key === "e" || param.key === "E") &&
                    param.preventDefault();
                }}
              />
        </Box>
      </AccordianContainer>
    </>
  );
};

export default HouseholdAssessmentExpenses;
